import React from 'react';
import PropTypes from 'prop-types';
import { i18n, formatDate, formatNumber } from '../../Utility/Format';

import CurrencyChangeValue from '../Widgets/CurrencyChangeValue';
import CurrencyPairLink from '../Helper/CurrencyPairLink';
import CurrencyTable, { CurrencyTableColumnsGroup, scrollableCellStyle } from '../Tables/CurrencyTable';

/*const getFixedRows = (rows) => {
    return {
        headerRow: (
            <tr>
                <th>{i18n('dbm.currency.ccyPair')}</th>
            </tr>
        ),
        contentRows: (
            rows.map((row) => {
                return (
                    <tr key={row.ccyPair}>
                        <td>
                            <CurrencyPairLink currencyPair={row.ccyPair}/>
                        </td>
                    </tr>
                )
            })
        )
    };
};*/

const getOtherRows = (rows,locale) => {
    const numberOfScrollableCells = 8;
    const numberOfDecimals = 4;

    return {
        headerRow: (
            <tr>
                <th style={{ textAlign: 'left' }}>{i18n('dbm.currency.ccyPair')}</th>

               <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.bid')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.ask')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.changeAbsolute')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.changePercent')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.previousBid')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.previousAsk')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.valueDate')}
                </th>
            </tr>
        ),
        contentRows: (
            rows.map((row) => {
                return (
                    <tr key={row.ccyPair}>
                        <td style={{ textAlign: 'left' }}>
                            <CurrencyPairLink currencyPair={row.ccyPair} />
                        </td>

                        <td>
                            {row.bid ? formatNumber(row.bid, numberOfDecimals) : '–'}
                        </td>
                        <td>
                            {row.ask ? formatNumber(row.ask, numberOfDecimals) : '–'}
                        </td>
                        <td>
                            <CurrencyChangeValue value={row.changeAbsolute} fractionDigits={numberOfDecimals} showIcon={true} showText={true} />
                        </td>
                        <td>
                            <CurrencyChangeValue value={row.changePercent} fractionDigits={2} unit="%"
                                showIcon={false} showText={true} >
                            </CurrencyChangeValue>
                        </td>
                        <td>
                            {row.previousBid ? formatNumber(row.previousBid, numberOfDecimals) : '–'}
                        </td>
                        <td>
                            {row.previousAsk ? formatNumber(row.previousAsk, numberOfDecimals) : '–'}
                        </td>

                        <td>
                            {formatDate(row.valueDate, locale)}
                        </td>
                    </tr>

                )
            })
        )
    };
};

/**
 * SpotTable
 */
const SpotTable = (props) => {
    //  const fixedRows = getFixedRows(props.rows);
    const otherRows = getOtherRows(props.rows, props.locale);

    return (
        <CurrencyTable>
            {/* <CurrencyTableColumnsGroup
                isFixed={true}
                headerRow={fixedRows.headerRow}
                contentRows={fixedRows.contentRows}
            /> */}
            <CurrencyTableColumnsGroup
                headerRow={otherRows.headerRow}
                contentRows={otherRows.contentRows}
            />
        </CurrencyTable>
    );
};

SpotTable.propTypes = {
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            bid: PropTypes.number,
            ask: PropTypes.number,
            previousBid: PropTypes.number,
            previousAsk: PropTypes.number,
            changeAbsolute: PropTypes.number,
            changePercent: PropTypes.number,
            ccyPair: PropTypes.string,
            valueDate: PropTypes.string
        })
    ),
    locale: PropTypes.string
};

export default SpotTable;